import { render, staticRenderFns } from "./Disconect.vue?vue&type=template&id=29c45bec&scoped=true&"
import script from "./Disconect.vue?vue&type=script&lang=js&"
export * from "./Disconect.vue?vue&type=script&lang=js&"
import style0 from "./Disconect.vue?vue&type=style&index=0&id=29c45bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c45bec",
  null
  
)

export default component.exports